import {h, Fragment} from "preact";
import { msg } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";

import formatOdd from "../../../services/odds-format";
import MoneyFormatter from "../utils/money-formatter";

export function TicketPopup({children}) {
	return <div class="fixed z-10 inset-0 bg-harif-800 text-white overflow-auto overscroll-y-contain">
		{children}
	</div>
}

export function MobileTopRow({children}) {
	return <div class="fn-ticket-top-row flex h-10 w-full items-center bg-harif-800 text-sm text-white">
		{children}
	</div>
}

export function BetslipButton({children, active, onClick}) {
	if (!active)
		return <div class="flex h-full min-w-0 grow items-center justify-between px-1" onClick={onClick}>
			{children}
		</div>
	return <div class="flex h-full min-w-0 grow items-center justify-between px-1 text-custom-orange" onClick={onClick}>
		{children}
	</div>
}
export function CashoutButton({children, active, onClick}) {
	if (!active)
		return <div class="flex grow h-10 justify-center items-center text-base bg-custom-orange cursor-pointer hover:text-white" onClick={onClick}>
			{children}
		</div>
	return <div class="flex grow h-10 items-center text-white bg-amber-400 uppercase" onClick={onClick}>
		{children}
	</div>
}
export function BetslipButtonLarge({children, active, onClick}) {
	if (!active)
		return <div class="flex grow h-10 justify-center items-center px-1" onClick={onClick}>
			{children}
		</div>
	return <div class="flex h-10 grow justify-center items-center px-3 text-base text-white bg-amber-400 uppercase" onClick={onClick}>
		{children}
	</div>
}
export function BetslipSettingsRow({children}){
	return <div class="flex justify-between w-full px-2">
			{children}
		</div>
}
export function BestslipCloseButton({onClick, children}) {
	return <div class="flex h-full w-6 items-center justify-between mx-1" onClick={onClick}>{children}</div>
}

export function BetslipIndicator({children}) {
	return <div class="text-xxs h-4 w-4 rounded-full bg-custom-orange text-center leading-4 text-black">{children}</div>
}

export function BestlipOddsSection({children}) {
	return <div class="fn-ticket-top-row flex w-full flex-col items-center gap-1 border-b border-b-harifzinc-950 bg-harif-800 p-1 pb-2 text-sm text-white">
		{children}
	</div>
}

export function TicketRow({children, closed}) {
	if (closed)
		return <div class="fn-ticket-row w-full bg-harif-900 p-0.5 text-white rounded-lg border-2 border-red-500">
			{children}
		</div>
	return <div class="fn-ticket-row w-full bg-harif-900 p-0.5 text-white">
		{children}
	</div>
}

export function OddsError({children}) {
	return <div class="bg-red-500 text-white rounded-lg py-1 px-2 text-xs w-full">
		{children}
	</div>
}

export function TicketEventHeader({children}) {
	return <div class="fn-ticket-event-header flex pb-2">
		{children}
	</div>
}

export function TicketEventOdd({children, closed}) {
	if (closed)
		return <div class="flex px-1 py-1 text-xs items-center gap-1 rounded-lg border-2 border-red-500 flex-wrap">
			{children}
		</div>
	return <div class="flex px-1 py-1 text-xs items-end rounded-lg">
		{children}
	</div>
}

export function TicketEventName({children}) {
	return <div class="flex h-8 w-full min-w-0 items-center truncate bg-harif-800 px-1 text-xs text-white font-bold uppercase">
		{children}
	</div>
}

export function TicketEventRemoveBtn({onClick, children}) {
	return <div class="flex w-8 shrink-0 grow-0 items-center justify-center" onClick={onClick}>{children}</div>
}

export function TicketSystemOddsLockBtn({onClick, children}) {
	return <div class="flex w-8 shrink-0 grow-0 items-center justify-center" onClick={onClick}>{children}</div>
}

export function MarketContainer({children}) {
	return <div class="min-w-0 truncate grow font-bold uppercase">{children}</div>
}

export function OutcomeName({children}) {
	return <span class="border border-harifzinc-900 px-1">{children}</span>
}

export function OutcomeValue({value}) {
	return <div class="px-1 font-bold text-custom-orange-dark">{formatOdd(value)}</div>
}

export function TicketSelectionsRowLarge({children}) {
	return <div class="hidden h-14 w-full items-center border-b border-t border-b-harifzinc-900 border-t-harifzinc-700 bg-harif-950 text-white">
		<div class="flex w-full p-2">
			{children}
		</div>
	</div>
}

export function SelectionTypeButton({children, active, onClick}) {
	if (!active)
		return <div class="w-1/2 shrink grow bg-harif-950 py-2 text-center text-sm font-bold uppercase text-white" onClick={onClick}>
			{children}
		</div>
	return <div class="w-1/2 shrink grow bg-harif-800 py-2 text-center text-sm font-bold uppercase text-white" onClick={onClick}>
		{children}
	</div>
}

	export function TicketTotalOddRow({children}) {
		return <div class="flex h-9 w-full items-center border-b border-t border-b-harif-900 border-t-harif-950 bg-harif-800 text-white">
			<div class="flex w-full justify-between text-sm">
				{children}
			</div>
		</div>
	}

export function PaddedCell({children}) {
	return <div class="p-2">
		{children}
	</div>
}

export function PaddedCellHalfWidth({children}) {
	return <div class="p-2 w-1/2">
		{children}
	</div>
}

export function PaddedCellThirthWidth({children}) {
	return <div class="p-2 w-1/3">
		{children}
	</div>
}

export function TicketTotalStakeRow({children}) {
	return <div class="flex h-10 w-full items-center border-b border-t border-b-harif-900 border-t-harif-950 bg-harif-800 text-white">
		<div class="flex w-full items-center justify-between text-sm">
			{children}
		</div>
	</div>
}

export function TicketSystemStakeRow({children}) {
	return <div class="flex h-10 w-full items-center border-b border-t border-b-harif-900 border-t-harif-950 bg-harif-800 text-white">
		<div class="flex w-full items-center justify-between text-xs">
			{children}
		</div>
	</div>
}

export function TicketSystemPreviewRow({children}) {
	return <div class="flex h-8 w-full items-center border-b border-t border-b-harifzinc-900 border-t-harifzinc-700 bg-harifzinc-800 text-white">
		<div class="flex w-full items-center justify-between text-xs">
			{children}
		</div>
	</div>
}

export const TicketSystemStakeName = (num) => {
	const names = {
		1: window.Translation(msg`Singola`),
		2: window.Translation(msg`Doppia`),
		3: window.Translation(msg`Tripla`),
		4: window.Translation(msg`Quadrupla`),
		5: window.Translation(msg`Quintupla`),
	};
	return names[num] || window.Translation(msg`${num} Esiti`);
}

export const TicketSystemPreviewMinWin = ({minwin}) => <div class="flex text-xxs text-center">
	<span class="w-full"><Trans>Vinc. min.</Trans></span>
	<span class="w-full"><MoneyFormatter value={minwin} /></span>
</div>;

export const TicketSystemPreviewMaxWin = ({maxwin}) => <div class="flex text-xxs text-center">
	<span class="w-full"><Trans>Vinc. min.</Trans></span>
	<span class="w-full"><MoneyFormatter value={maxwin} /></span>
</div>;

export function StakeInput({onInput, onBlur, onIncrement, onDecrement, value}) {
	return <div class="mx-2 flex w-full h-7 rounded bg-harif-900">
		<div class="cursor-pointer select-none flex h-7 w-7 flex-none items-center justify-center rounded-l bg-harif-850 text-white pb-0.5" onClick={onDecrement}>-</div>
		<input class="color-white w-full bg-transparent px-1 text-center" placeholder="Unit Stake" type="text" value={value} onInput={onInput} onBlur={onBlur} />
		<div class="cursor-pointer select-none flex h-7 w-7 flex-none items-center justify-center rounded-r bg-harif-850 text-white" onClick={onIncrement}>+</div>
	</div>
}

export function RegularTicketWinPreview({children}) {
	return <div class="fn-max-win justify-between flex w-full items-center border-b border-b-harifzinc-900 border-t-harifzinc-700 bg-harifzinc-800 text-slate-50 p-2">
		{children}
	</div>;
}
export function RegularTicketWinLabel({children}) {
	return <span class="text-xs">{children}</span>
}
export function RegularTicketWinAmount({children}) {
	return <span class="text-xs italic text-slate-50">{children}</span>
}
export function RegularTicketWinAmountBold({children}) {
	return <span class="text-lg font-bold text-white">{children}</span>
}

export function WarningRow({children}) {
	return <div class="flex h-10 w-full items-center border-b border-t border-b-harifzinc-900 border-t-harifzinc-700 bg-harifzinc-800 text-white">
		<div class="flex w-full items-center justify-start p-2 text-xs">
			{children}
		</div>
	</div>
}

export function WarningIcon() {
	return <span class="icon-attention text-base pb-0.5">&#x26A0;</span>
}

export function TicketHelperButtonsContainer({children}) {
	return <div class="flex w-full items-center border-b border-b-harif-950 bg-harif-900 text-white">
		<div class="flex flex-col w-full flex-wrap gap-2 p-2">
			{children}
		</div>
	</div>
}
export function TicketButtonsContainer({children}) {
	return <div class="flex w-full items-center border-b border-t border-b-harifzinc-900 border-t-harifzinc-700 bg-harifzinc-800 text-white">
		<div class="flex w-full flex-wrap gap-2 p-2">
			{children}
		</div>
	</div>
}

export function SaveButton({children, onClick, disabled}) {
	if (disabled) {
		return <div
			   class="fn-prenota flex w-full justify-between items-center h-8 bg-harif-800 text-slate-100 px-2 rounded cursor-not-allowed"
			>
			{children}
		</div>
	}
	return <div
		   class="fn-prenota flex w-full justify-between items-center h-8 bg-harif-800 text-slate-100 px-2 rounded cursor-pointer hover:bg-harif-925"
		   onClick={onClick}
		>
		{children}
	</div>
}

export function CancelButton({children, onClick}) {
	return <div
		   class="flex grow justify-between items-center h-14 bg-red-700 px-2 w-1/2 cursor-pointer hover:bg-red-600"
		   onClick={onClick}
		>
		{children}
	</div>
}

export function PlaceButton({children, onClick, disabled}) {
	if (disabled) {
		return <div
			   class="flex grow justify-center items-center h-14 bg-green-700 px-2 w-1/2 cursor-not-allowed"
			>
			{children}
		</div>
	}
	return <div
		   class="flex grow justify-center items-center h-14 bg-green-700 px-2 w-1/2 cursor-pointer hover:bg-green-800"
		   onClick={onClick}
		>
		{children}
	</div>
}
export function PlacedTicketButtonsContainer({children}) {
	return <div class="flex w-full items-center border-b border-b-slate-300 bg-harif-900 text-white">
		<div class="grid grid-cols-2 w-full flex-wrap gap-2 p-2">
			{children}
		</div>
	</div>
}

export function PlacedSaveButton({children, onClick, disabled}) {
	if (disabled) {
		return <div
			   class="fn-prenota w-1/2 rounded py-3 text-center text-sm font-semibold uppercase bg-slate-400 cursor-not-allowed"
			>
			{children}
		</div>
	}
	return <div
		   class="fn-prenota w-1/2 rounded bg-custom-orange py-3 text-center text-sm font-semibold uppercase cursor-pointer hover:bg-amber-400"
		   onClick={onClick}
		>
		{children}
	</div>
}

export function PlacedCancelButton({children, onClick}) {
	return <div
		   class="fn-cancel-betslip w-full grow rounded bg-amber-400 py-3 text-center text-sm font-semibold uppercase cursor-pointer hover:bg-custom-orange"
		   onClick={onClick}
		>
		{children}
	</div>
}

export function PlacedPlaceButton({children, onClick, disabled}) {
	if (disabled) {
		return <div
			   class="fn-place-ticket w-full grow rounded py-3 text-center text-sm font-semibold uppercase bg-slate-400 cursor-not-allowed"
			>
			{children}
		</div>
	}
	return <div
		   class="fn-place-ticket w-full grow rounded bg-custom-orange py-3 text-center text-sm font-semibold uppercase cursor-pointer hover:bg-amber-400"
		   onClick={onClick}
		>
		{children}
	</div>
}

export function TicketBonusPanel({children}) {
	return <div class="p-2 py-1 h-12 bg-harif-800 text-custom-orange-dark text-xs font-bold">
		{children}
	</div>
}
export function TicketBonusInfoRow({children}) {
	return <div class="flex justify-between">
		{children}
	</div>
}
export function TicketBonusInfoCell({children}) {
	return <div class="">{children}</div>
}
export function Progressbar({percentage}) {
	return <div class="pt-2">
		<div class="w-full rounded-full bg-harifzinc-800 h-2 overflow-hidden">
			<div class="rounded-full bg-custom-orange h-full" style={"width: "+(percentage*100)+"%"}></div>
		</div>
	</div>
}

function TicketExample() {
	return <Fragment>
		<MobileTopRow>
		  <BetslipButton>
			<span>Betslip</span>
			<BetslipIndicator>2</BetslipIndicator>
		  </BetslipButton>
		  <BetslipButton>My Bets</BetslipButton>
		  <BetslipButton>Settings</BetslipButton>
		  <BetslipButton>Decimal</BetslipButton>
		  <BestslipCloseButton />
		</MobileTopRow>
		<BestlipOddsSection>
		  <TicketRow>
			<TicketEventHeader>
			  <TicketEventName>Argentina (Wom) - Venezuela (Wom)</TicketEventName>
			  <TicketEventRemoveBtn />
			</TicketEventHeader>
			<TicketEventOdd>
			  <MarketContainer>Match Result: <OutcomeName>X</OutcomeName></MarketContainer>
			  <OutcomeValue value={3.88} />
			</TicketEventOdd>
		  </TicketRow>
		  <TicketRow>
			<TicketEventHeader>
			  <TicketEventName>Argentina (Wom) - Venezuela (Wom)</TicketEventName>
			  <TicketEventRemoveBtn />
			</TicketEventHeader>
			<TicketEventOdd>
			  <MarketContainer>Match Result: <OutcomeName>X</OutcomeName></MarketContainer>
			  <OutcomeValue value={3.88} />
			</TicketEventOdd>
		  </TicketRow>
		</BestlipOddsSection>
		<TicketSelectionsRowLarge>
		  <SelectionTypeButton active={true}>MULTIPLE</SelectionTypeButton>
		  <SelectionTypeButton active={false}>SYSTEM</SelectionTypeButton>
		</TicketSelectionsRowLarge>
		<TicketTotalOddRow>
		  <PaddedCell>Odds</PaddedCell>
		  <PaddedCell>8.30</PaddedCell>
		</TicketTotalOddRow>
		<TicketTotalStakeRow>
		  <PaddedCell>Stake</PaddedCell>
		  <StakeInput />
		</TicketTotalStakeRow>
		<WarningRow>
		  <WarningIcon /> You need to login to be able to place a bet.
		</WarningRow>
		<TicketButtonsContainer>
		  <SaveButton>SAVE</SaveButton>
		  <CancelButton>Cancel</CancelButton>
		  <PlaceButton>Place Bet</PlaceButton>
		</TicketButtonsContainer>
	</Fragment>
}



export function StatusMessage({children}) {
	return <div class="w-full bg-harif-900 text-white">
		<div class="flex flex-col items-center w-full p-2 gap-1">
			{children}
		</div>
	</div>
}
export function StatusMessageText({children}){
	return <div class="text-center text-base">{children}</div>
}
export function StatusMessageButtons({children}){
	return <div class="flex gap-1 w-full flex-wrap text-white">{children}</div>
}

export const StatusMessageCancel = PlacedCancelButton
export const StatusMessageAccept = PlacedPlaceButton
